import { z } from "zod";

import { extractTranslations } from "@/services/cms";

export const getCompanyMetaResponseSchema = z
  .object({
    data: z.preprocess(
      extractTranslations,
      z.object({
        translations: z.object({
          instagramUrl: z.string(),
          linkedinUrl: z.string(),
          facebookUrl: z.string(),
          newsletterTermsLink: z.string().min(3),
          consultationPollLink: z.string().min(3),
          minHomeVisitPrice: z.number().min(0),
          rafDiscountAmount: z.number().min(0),
          rafMinBasketAmount: z.number().min(0),
          packagesTestsTableAnnotation: z.string().min(3),
          contactItems: z.array(z.object({ name: z.string(), email: z.string() })).min(2),
        }),
      }),
    ),
  })
  .transform(({ data }) => ({ ...data }));
